// modules
import { useCallback, useEffect, useRef } from 'react'
import { Recorder, Voice } from '@weblite/voice-recorder'
// helpers
import { getVoiceWave } from '$func/voice-wave'
import { convertVoiceToFile } from '$logic/message'
import { RecordedVoice } from '$comp/_app/components/chat/components/footer/components/send-field/components/voice-recorder/types'
import { RecorderStatus } from '../../../send-field.type'

const config = {
  wasmURL: '/assets/vmsg/vmsg.wasm',
  shimURL: '/assets/vmsg/wasm-polyfill.js',
}
const recorder = new Recorder(config)

export const useReactRecorder = ({
  state,
  setRecorderState,
  setRecorderVoice,
}: {
  state: RecorderStatus
  setRecorderState: (newState: RecorderStatus) => unknown
  setRecorderVoice: (voice: RecordedVoice) => unknown
}) => {
  const recording = state === 'STARTING' || state === 'RECORD'

  const MIN_DURATION = 1000

  const isAlreadyRecording = useRef<boolean>(false)

  const onRecordStart = useCallback(() => {
    setRecorderState('RECORD')
  }, [])

  const onRecordStop = useCallback(async (voice: Voice) => {
    if (voice.duration < MIN_DURATION) setRecorderState('IDLE')
    else {
      try {
        const file = convertVoiceToFile(voice)
        const wave = await getVoiceWave(file)
        setRecorderVoice({ ...voice, wave })
        setRecorderState('PREVIEW')
      } catch (e) {
        // handle error
      }
    }
  }, []) // TODO: check this dependency on voice upload

  useEffect(() => {
    if (!recording) {
      recorder
        .stop()
        .then(v => {
          isAlreadyRecording.current = false
          onRecordStop(v)
        })
        .catch((error: any) =>
          // eslint-disable-next-line no-console
          console.log('Error occurred when stopping recording:', error),
        )
    } else if (recording) {
      recorder
        .start()
        .then(() => {
          onRecordStart()
          isAlreadyRecording.current = true
        })
        .catch((error: any) =>
          // eslint-disable-next-line no-console
          console.log('Error occurred when starting recording:', error),
        )
    }
  }, [recording])

  useEffect(() => {
    return () => {
      if (isAlreadyRecording.current) {
        recorder.stop()
      }
    }
  }, [])
}
